import { useDispatch } from 'react-redux'
import { MapBar as AppBar } from 'ui-components'
import { useAuth } from 'user-auth'
import { useIsEmbed } from '~map-preview/hooks/useIsEmbed'
import { closeMapDescriptionDrawer } from '~map-preview/states/ui'
import { MapDetailsButton } from './MapDetailsButton'
import { MapFilterButton } from './MapFilterButton'
import { MapSearchButton } from './MapSearchButton'
import { MapShareButton } from './MapShareButton'
import { NavButton } from './NavButton'

export function MapBar() {
  const isEmbed = useIsEmbed()
  const dispatch = useDispatch()
  const { authenticated } = useAuth()

  const handleClose = () => {
    dispatch(closeMapDescriptionDrawer())
  }

  return (
    <AppBar
      isEmbed={isEmbed}
      authenticated={authenticated}
      onClose={handleClose}
      slots={{
        NavButton,
        MapSearchButton,
        MapFilterButton,
        MapDetailsButton,
        MapShareButton
      }}
    />
  )
}
